import { type Brand } from '@/consts/brands';
import { BASE_PATH } from '@/consts/environmental';
import { urls } from '@/utils/urls';

export const getLoginUrlWithRedirect = (brand: Brand, redirect: string) => {
  return `${urls[brand].legacy.auth.login}${
    redirect
      ? '?signupRedirect=' +
        BASE_PATH +
        encodeURIComponent(redirect.replace(/\/register$/, ''))
      : ''
  }`;
};
